




























































































import { TransaksiFarmasiItem } from "@/types/obat_farmasi";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";

@Component({})
export default class ModalResumeOptionItem extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() readonly title!: string;
  @Prop() listItems: TransaksiFarmasiItem[] = [];

  get show() {
    return this.value;
  }
  set show(value) {
    this.$emit("input", value);
  }

  get renderedListItems() {
    // get only unique items on list
    const items = this.filteredListItems.filter(
      (obj, index) =>
        this.filteredListItems.findIndex(
          item =>
            item.kode === obj.kode &&
            item.qty === obj.qty &&
            item.aturan_pakai?.id === obj.aturan_pakai?.id
        ) === index
    );

    return items;
  }

  get filteredListItems() {
    // get only jenis obat
    return this.listItems
      .filter(item => item?.jenis_resep != "4")
      .sort((a, b) => {
        return (
          new Date(b.tgl_trans).getTime() - new Date(a.tgl_trans).getTime()
        );
      })
      .map(trx => trx.items)
      .flatMap(item => {
        return item;
      })
      .filter(item => item.jenis === "obat");
  }

  get obatPulangListItems() {
    // get only jenis obat
    return this.listItems
      .filter(item => item?.jenis_resep == "4")
      .sort((a, b) => {
        return (
          new Date(b.tgl_trans).getTime() - new Date(a.tgl_trans).getTime()
        );
      })
      .map(trx => trx.items)
      .flatMap(item => {
        return item;
      })
      .filter(item => item.jenis === "obat");
  }

  checkedItems = null;
  checkedAll = false;

  getIdCheckbox(kode, idx) {
    return kode + idx.toString();
  }

  getItemLabel(item) {
    return (
      item.nama +
      " " +
      item.qty +
      " " +
      item.satuan +
      (item.aturan_pakai ? " " + item.aturan_pakai.nama : "")
    );
  }

  getItem() {
    console.log("get item", this.checkedItems);
    this.show = false;
    this.$emit("set-item", this.checkedItems);
  }

  cancel() {
    this.show = false;
  }

  @Watch("show")
  changedShow(val) {
    if (!val) {
      this.checkedItems = null;
    }
  }

  @Watch("checkedAll")
  changedCheckedAll(val) {
    if (!val) {
      this.checkedItems = null;
    } else {
      this.checkedItems = this.listItems;
    }
  }
}
